import { getDayLabel } from 'utils/getDayLabel';

export const getFormattedDaysNumber = (daysNumber: number) =>
    `${daysNumber} ${getDayLabel(daysNumber)}`;
